import { Card } from "antd";
import { useEffect, useState } from "react";
import {
  FindAllInterviewSchedulesFilters,
  PaginationType,
} from "../../Interface";
import { InterviewWithJobPost } from "../../Entities/Interview";
import interviewService from "../../Service/interview.service";
import InterviewsTable from "./InterviewsTable";
import dayjs from "dayjs";
import { useAuth } from "../../Context/AuthContext/AuthContext";
import { User } from "../../Entities/User";
import "./index.scss";

const ScheduledInterviews = () => {
  const { user } = useAuth();

  const [pagination, setPagination] = useState<PaginationType>({
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
  });
  const [filters, setFilters] = useState<FindAllInterviewSchedulesFilters>({
    search: null,
    jobPost: null,
    date: dayjs().format("YYYY-MM-DD"),
    organizer: null,
    status: null,
  });

  const [filterOptions, setFilterOptions] = useState<{
    jobPosts: { _id: string; title: string }[];
    interviewers: { _id: string; name: string }[];
  }>({
    jobPosts: [],
    interviewers: [],
  });

  const [interviewSchedules, setInterviewSchedules] = useState<
    InterviewWithJobPost[]
  >([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFilterOptions = async (currentUser: User) => {
      const response = await interviewService.getFilterOptions();
      if (response) {
        setFilterOptions({
          jobPosts: response?.jobPosts,
          interviewers: response?.interviewers,
        });
        const isUserAvailable = response?.interviewers.some(
          (interviewer: any) => interviewer._id === currentUser._id
        );

        if (isUserAvailable) {
          setFilters((prev) => ({
            ...prev,
            organizer: currentUser._id,
          }));
        }
      }
    };
    if (user) {
      fetchFilterOptions(user);
    }
  }, [user]);

  useEffect(() => {
    const fetchInterviews = async () => {
      try {
        setLoading(true);
        const response = await interviewService.searchInterviewsByNameOrEmail(
          filters,
          pagination
        );
        setInterviewSchedules(response.data);
        setPagination({
          ...pagination,
          totalRecords: response.totalRecords,
          totalPages: response.totalPages,
        });
      } catch (error) {
        console.error("Failed to fetch interviews:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInterviews();
  }, [filters, pagination.page, pagination.limit]);

  const handlePageChange = (page: number) => {
    setPagination({ ...pagination, page });
  };

  const updateFilters = (
    key: keyof FindAllInterviewSchedulesFilters,
    value: string | null
  ) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));

    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  const clearFilters = () => {
    setFilters({
      search: null,
      jobPost: null,
      date: null,
      organizer: null,
      status: null,
    });
    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  return (
    <div className="scheduled-interviews-card">
      <Card
        title="Scheduled Interviews"
        className="scheduled-interviews-card-container"
      >
        <div className="table-wrapper">
          <InterviewsTable
            pagination={pagination}
            filterOptions={filterOptions}
            filters={filters}
            interviewSchedules={interviewSchedules}
            updateFilters={updateFilters}
            handlePageChange={handlePageChange}
            clearFilters={clearFilters}
            loading={loading}
          />
        </div>
      </Card>
    </div>
  );
};

export default ScheduledInterviews;
